import {Button, Dropdown} from '@/components/atoms'
import { SectionTitle } from '@/components/molecules'
import { FONT_SIZE } from '@/utils/constants/globalStyle'

function CategoryWrapper({ categories, selectedCategory, setSelectedCategory, selectedCategoryInitialState=[] }) {
  const handleReset = () => {
    // Reset the selected categories when reset is clicked
    setSelectedCategory(selectedCategoryInitialState)
  }

  const handleCategoryChange = value => {
    setSelectedCategory(value)
  }

  // Convert the backend data to the dropdown list format
  const dropdownList =
    categories?.length &&
    categories?.map(item => ({
      displayText: item?.category,
      id: item?.categoryId,
      isBadge: false,
    }))
  return (
    <>
      <div className="category-header-wrap mb-6">
        <SectionTitle label="Select Categories to Include" fontSize={FONT_SIZE.XXXL}></SectionTitle>
        <Button
          handleButton={handleReset}
          uiSchema={{
            className: 'float-right',
            size: 'medium',
            title: 'Reset',
            variant: 'secondary',
            isDark: true,
          }}
        />
      </div>
      <div className="grid grid-cols-4">
        <Dropdown
          isJsonWrap={false}
          childList={dropdownList}
          isDark={true}
          label="Category *"
          // placeholder={isAllCategories ? 'All Categories' : 'Select Categories'}
          placeholder={'Select Categories'}
          selection="multiple"
          updateValue={handleCategoryChange}
          size="medium"
          value={selectedCategory}
        />
      </div>
    </>
  )
}

export default CategoryWrapper
